import checkedBoxes from './checkedBoxes'
import mountServiceData from './mountServiceData'
import mountSegmentData from './mountSegmentData'

export default { checkedBoxes, mountServiceData, mountSegmentData }
